export default __webpack_public_path__ + "static/media/img save n upload.18f59470.jpg";